import "../../homepage/impact/Impact.scss";
import infrastructureresillience from "../../../assets/images/infrastructureresillience.png";
import naturebasedsolutions from "../../../assets/images/naturebasedsolutions.png";
import communityresillience from "../../../assets/images/communityresillience.png";
import riskmanagement from "../../../assets/images/riskmanagement.png";
import { useEffect, useRef, useState } from "react";
import * as $ from "jquery";
import { useNavigate } from "react-router-dom";

const IconTabs = () => {
  const iconsectionright = useRef();
  const impactbutton1 = useRef();
  const impactbutton2 = useRef();
  const impactbutton3 = useRef();
  const impactbutton4 = useRef();
  const [iconbodycontent, setIconBodyContent] = useState(<></>);

  const navigate = useNavigate();

  useEffect(() => {
    onInfrastructureResilience();

    $(window).scroll(function (event) {
      $(this).scrollTop();
    });
  }, []);

  const iconbody = ({
    iconid = "archetype-icon-1",
    iconsrc = infrastructureresillience,
    description = "",
    potentialfunding = [{}],
    totalprojects = 16,
    totalbudget = "~$7 BILLION",
    projects = [{}],
    searchtitle = "Infrastructure Resilience",
  }) => {
    return (
      <div id="archetypes-icon-tab-body">
        <div className="custom-row icon-tab-header">
          <img id={iconid} src={iconsrc} alt="slr" className="archetype-img" />
          <div className="custom-row kpis">
            <div>
              <div className="title"># OF PROJECTS</div>
              <div className="subtitle">{totalprojects}</div>
            </div>
            <div>
              <div className="title">TOTAL PROJECT PORTFOLIO BUDGET</div>
              <div className="subtitle">{totalbudget}</div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="custom-col">
            <div className="cid-driver-bullet-parent top-section">
              <div className="custom-row">
                <div className="custom-col">
                  <div className="archetypes-title">DESCRIPTION</div>
                  <div>{description}</div>
                </div>
                <div className="custom-col">
                  <div className="archetypes-title">
                    POTENTIAL TYPE OF EXTERNAL FUNDING
                  </div>
                  <ul>
                    {potentialfunding.map((obj, i) => {
                      return <li key={i}>{obj.desc}</li>;
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="custom-col">
              <div className="archetypes-title">PROJECTS</div>
              <ul>
                {projects.map((obj, i) => {
                  return <li key={i}>{obj.desc}</li>;
                })}
              </ul>
            </div>
            <button
              className="view-details-btn"
              onClick={() => {
                navigate(`/Project/${searchtitle}`);
              }}
            >
              VIEW DETAILS
            </button>
          </div>
        </div>
      </div>
    );
  };

  const onInfrastructureResilience = () => {
    iconsectionright.current.style.setProperty("display", "initial");
    impactbutton1.current.classList.add("active");
    impactbutton2.current.classList.remove("active");
    impactbutton3.current.classList.remove("active");
    impactbutton4.current.classList.remove("active");

    setIconBodyContent(
      iconbody({
        iconid: "archetype-icon-1",
        iconsrc: infrastructureresillience,
        description:
          "Develops robust physical and technical infrastructure to withstand and mitigate climate risks, including floods, heat, and sea-level rise.",
        potentialfunding: [
          {
            desc: "Public-Private Partnerships (PPPs)",
          },
          {
            desc: "Sovereign and municipal green bonds",
          },
          {
            desc: "Multilateral loans",
          },
          {
            desc: "Infrastructure-specific grants",
          },
        ],
        totalprojects: 16,
        totalbudget: "~$7 BILLION",
        projects: [
          {
            desc: "Flood prevention and clean energy via waste collection and incineration",
          },
          {
            desc: "Targeted wastewater treatment to prevent flood-contaminated drinking water",
          },
          {
            desc: "Clean drinking water source in areas with failing groundwater supply",
          },
          { desc: "Resilient road and transit links in inundated areas" },
          {
            desc: "Protecting inundated power and communications infrastructure",
          },
          {
            desc: "Rainwater harvesting on commercial buildings to reduce extreme rainfall-related flooding",
          },
          { desc: "Resilient water links for Lagos inner-city connections" },
          {
            desc: "Strengthened sea defenses to reinforce existing coastal embarkment",
          },
          {
            desc: "Inner-city flood prevention through new primary drainage systems",
          },
          {
            desc: "Inner-city flood prevention through new and rehabilitated secondary drainage systems",
          },
          {
            desc: "Flood-enhanced inner-city roads across 10 vulnerable governmental areas",
          },
          {
            desc: "Retrofitted pavements of 1,800km for extreme heat mitigation",
          },
          {
            desc: "Expanded stormwater channels for enhanced flood management",
          },
          {
            desc: "Protective artificial flood barriers for climate-resilient community areas",
          },
        ],
        searchtitle: "Infrastructure Resilience",
      })
    );
  };
  const onNatureBasedSolutions = () => {
    iconsectionright.current.style.setProperty("display", "initial");
    impactbutton1.current.classList.remove("active");
    impactbutton2.current.classList.add("active");
    impactbutton3.current.classList.remove("active");
    impactbutton4.current.classList.remove("active");

    setIconBodyContent(
      iconbody({
        iconid: "archetype-icon-2",
        iconsrc: naturebasedsolutions,
        description:
          "Leverages ecosystems to address climate challenges, enhancing environmental and community resilience.",
        potentialfunding: [
          {
            desc: "Grants from biodiversity and climate-focused funds",
          },
          {
            desc: "Carbon credits financing",
          },
          {
            desc: "Bilateral aid",
          },
          {
            desc: "Debt-for-nature swaps",
          },
        ],
        totalprojects: 5,
        totalbudget: "~$150 MILLION",
        projects: [
          {
            desc: "Inland flood prevention through mangrove restoration across Lagos",
          },
          { desc: "Water-resilient agriculture and agroforestry" },
          { desc: "Planting of climate-resilient trees across Lagos" },
          { desc: "Rehabilitate and maintenance of existing urban parks" },
          { desc: "Nature-based inland flood solutions" },
        ],
        searchtitle: "Nature-Based Solutions",
      })
    );

    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("opacity", "0");
    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("transition", "all 1.5s");
    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("opacity", "1");
  };
  const onCommunityResilience = () => {
    iconsectionright.current.style.setProperty("display", "initial");
    impactbutton1.current.classList.remove("active");
    impactbutton2.current.classList.remove("active");
    impactbutton3.current.classList.add("active");
    impactbutton4.current.classList.remove("active");

    setIconBodyContent(
      iconbody({
        iconid: "archetype-icon-3",
        iconsrc: communityresillience,
        description:
          "Focuses on safeguarding vulnerable populations, improving health systems, and ensuring equitable climate adaptation.",
        potentialfunding: [
          {
            desc: "Social impact bonds",
          },
          {
            desc: "Impact investment funds",
          },
          {
            desc: "Grants from health and social welfare-focused organizations",
          },
          {
            desc: "Bilateral and multilateral funding partnerships",
          },
        ],
        totalprojects: 9,
        totalbudget: "~$1 BILLION",
        projects: [
          {
            desc: "Implement surveillance systems for climate change-related existing and new diseases",
          },
          {
            desc: "Relocating permanently displaced populations to climate responsive housing",
          },
          {
            desc: "Resilient aquafarming facilities designed to minimize yield losses caused by flooding",
          },
          { desc: "Heat-alleviating adaptation of social infrastructures" },
          { desc: "Flood and heat-retrofit of schools and health centers" },
          {
            desc: "Safe relocation and empowerment for vulnerable populations",
          },
          {
            desc: "Medical infrastructure blueprint alleviating climate risk-related healthcare demand",
          },
          {
            desc: "Digitalization to enable a climate-resilient healthcare system",
          },
          {
            desc: "Health insurance access for vulnerable communities in exposed governmental areas",
          },
        ],
        searchtitle: "Community Resilience & Health",
      })
    );

    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("opacity", "0");
    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("transition", "all 1.5s");
    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("opacity", "1");
  };
  const onRiskManagement = () => {
    iconsectionright.current.style.setProperty("display", "initial");
    impactbutton1.current.classList.remove("active");
    impactbutton2.current.classList.remove("active");
    impactbutton3.current.classList.remove("active");
    impactbutton4.current.classList.add("active");

    setIconBodyContent(
      iconbody({
        iconid: "archetype-icon-4",
        iconsrc: riskmanagement,
        description:
          "Enhances Lagos’ capacity to anticipate and respond to climate emergencies through technology and preparedness.",
        potentialfunding: [
          {
            desc: "Multilateral disaster risk financing",
          },
          {
            desc: "Concessional loans",
          },
          {
            desc: "Parametric insurance schemes",
          },
          {
            desc: "Technical assistance grants",
          },
        ],
        totalprojects: 4,
        totalbudget: "~$1 BILLION",
        projects: [
          { desc: "Early warning system for extreme weather events" },
          { desc: "Heat-reducing redesign of governmental area structures" },
          {
            desc: "Active water management with flood-resilient pumping stations",
          },
          { desc: "Creation of Lagos adaptation emergency response fund" },
        ],
        searchtitle: "Risk Management & Early Warning",
      })
    );

    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("opacity", "0");
    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("transition", "all 1.5s");
    document
      .getElementsByClassName("icontab-body")[0]
      .style.setProperty("opacity", "1");
  };
  return (
    <section>
      <div className="desktop icontabs">
        <div className="container">
          <div className="icontab-section">
            <div className="icontab-section-left">
              <button
                ref={impactbutton1}
                className="icontab"
                onClick={onInfrastructureResilience}
              >
                Infrastructure Resilience
              </button>
              <button
                ref={impactbutton2}
                onClick={onNatureBasedSolutions}
                className="icontab"
              >
                Nature-Based Solutions
              </button>
              <button
                ref={impactbutton3}
                onClick={onCommunityResilience}
                className="icontab"
              >
                Community Resilience & Health
              </button>
              <button
                ref={impactbutton4}
                onClick={onRiskManagement}
                className="icontab"
              >
                Risk Management & Early Warning
              </button>
            </div>
            <div ref={iconsectionright} className="icontab-section-right">
              {iconbodycontent}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IconTabs;
